import {
  persistCombineReducers,
  createTransform,
  persistReducer,
} from 'redux-persist';
import { StateFromReducersMapObject } from 'redux';
import localForage from 'localforage';
import ui from './ui';
import userLogin from './userLogin';
import hts from './hts';
import tables from './tables';
import isFetching from './isFetching';
import codeVersion from './code';
import openProducts from './openProducts';
import activeProduct from './activeProduct';
import recentlyViewed from './recentlyViewed';
import userStatus from './userStatus';
import { useSelector, TypedUseSelectorHook } from 'react-redux';

const resetPageNumbers = (tables: { [key: string]: { current: number } }) => {
  const keys = Object.keys(tables);
  for (const k of keys) {
    tables[k].current = 1;
  }
  return tables;
};

const safeTransform = createTransform(
  // transform state being rehydrated.
  (inboundState, key) => {
    return inboundState;
  },
  // transform state on its way to being serialized and persisted.
  // TODO fix typing once we have types for the tables slice of Redux.
  (outboundState: any, key) => {
    return resetPageNumbers(outboundState);
  },
  { whitelist: ['tables'] },
);

const htsPersist = persistReducer(
  {
    key: 'hts',
    storage: localForage,
    whitelist: ['usHtsHierarchy'],
  },
  hts,
);

const config = {
  key: 'inlt',
  whitelist: [
    'notifications',
    'codeVersion',
    'charts',
    'tables',
    'recentlyViewed',
  ],
  storage: localForage,
  throttle: 2000,
  transforms: [safeTransform],
};

const reducerMap = {
  isFetching,
  codeVersion,
  ui,
  tables,
  userLogin,
  openProducts,
  activeProduct,
  recentlyViewed,
  hts: htsPersist,
  userStatus,
};

export const rootReducer = persistCombineReducers(config, reducerMap);

export type RootState = StateFromReducersMapObject<typeof reducerMap>;
export const useTypedSelector: TypedUseSelectorHook<RootState> = useSelector;
